var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.89209H513V342.892H0V0.89209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 230.892H513V342.892H0V230.892Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1 132.692V99.9923H374V78.1923H352.1V89.0923H330.3V78.1923H308.5V99.9923H319.4V132.692H297.6V56.3923H308.5V34.5923H286.7V45.4923H275.8V34.5923H254V45.4923H243.1V34.5923H221.3V56.3923H232.2V132.692H210.4V99.9923H221.3V78.1923H199.5V89.0923H177.7V78.1923H155.9V99.9923H166.8V132.692H145V219.892H384.9V132.692H363.1Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.8 34.0923H243.6V44.9923H253.5V34.0923H276.3V44.9923H286.2V34.0923H309V56.8923H298.1V132.192H318.9V100.492H308V77.6923H330.8V88.5923H351.6V77.6923H374.5V100.492H363.6V132.192H385.4V220.392H144.5V132.192H166.3V100.492H155.4V77.6923H178.2V88.5923H199V77.6923H221.8V100.492H210.9V132.192H231.7V56.8923H220.8V34.0923ZM221.8 35.0923V55.8923H232.7V133.192H209.9V99.4923H220.8V78.6923H200V89.5923H177.2V78.6923H156.4V99.4923H167.3V133.192H145.5V219.392H384.4V133.192H362.6V99.4923H373.5V78.6923H352.6V89.5923H329.8V78.6923H309V99.4923H319.9V133.192H297.1V55.8923H308V35.0923H287.2V45.9923H275.3V35.0923H254.5V45.9923H242.6V35.0923H221.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9 236.392L240.7 254.592L259.8 268.892V300.192H236.6V309.192H259.6V317.092H236.6V326.392H270V268.892L289.1 254.592L264.9 236.392ZM264.9 261.692L254.8 254.592L264.9 247.492L275 254.592L264.9 261.692Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.201 235.993L289.933 254.593L270.5 269.143V326.892H236.1V316.592H259.1V309.692H236.1V299.692H259.3V269.143L239.867 254.593L264.6 235.993L264.9 236.392L265.201 235.993ZM264.9 237.018L241.533 254.591L260.3 268.642V300.692H237.1V308.692H260.1V317.592H237.1V325.892H269.5V268.642L288.267 254.591L264.9 237.018ZM264.9 246.881L275.87 254.592L264.9 262.303L253.931 254.592L264.9 246.881ZM255.67 254.592L264.9 261.081L274.131 254.592L264.9 248.103L255.67 254.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6 210.592V182.692C239.6 182.692 239.7 160.392 264.6 160.392C289.4 160.392 290.3 182.392 290.3 182.392V210.592H239.6ZM170.5 210.592V186.292C170.5 186.292 170.6 167.592 190.1 167.592C209.6 167.592 210.3 185.992 210.3 185.992V210.492H170.5V210.592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1 210.592V186.292C169.1 186.292 169.2 167.592 188.7 167.592C208.2 167.592 208.9 185.992 208.9 185.992V210.492H169.1V210.592ZM320.9 210.592V186.292C320.9 186.292 321 167.592 340.5 167.592C360 167.592 360.7 185.992 360.7 185.992V210.492H320.9V210.592ZM329.3 132.892V117.192C329.3 117.192 329.4 105.092 340.6 105.092C351.9 105.092 352.3 116.992 352.3 116.992V132.892H329.3ZM250.5 132.892V109.192C250.5 109.192 250.6 90.8921 264.8 90.8921C279 90.8921 279.5 108.892 279.5 108.892V132.892H250.5ZM177.5 132.892V117.192C177.5 117.192 177.6 105.092 188.8 105.092C200 105.092 200.5 116.992 200.5 116.992V132.892H177.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/GI.fb2b5c266236f2ec5a0d68484b3d3c98.svg";
export { ForwardRef as ReactComponent };